"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import NiceAvatar, { genConfig } from "react-nice-avatar";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

export type UserAvatarProps = {
	email: string;
	userName: string;
	profilePicture?: string | null;
	className?: string;
};

export function UserAvatar({
	email,
	userName,
	profilePicture,
	className,
}: UserAvatarProps) {
	const avatarConfig = genConfig(email);

	return (
		<Avatar className={cn("size-8 rounded-full", className)}>
			{profilePicture ? (
				<AvatarImage
					alt={userName}
					className="h-full w-full object-cover"
					src={profilePicture}
				/>
			) : null}
			<AvatarFallback>
				<NiceAvatar
					style={{ height: "100%", width: "100%" }}
					{...avatarConfig}
				/>
			</AvatarFallback>
		</Avatar>
	);
}
